import { useState } from 'react'
import { useCreateFeatureFlag } from '@/hooks/use-feature-flags'
import {
  isFeatureFlagClipboardText,
  parseFeatureFlagClipboard,
} from '../lib/feature-flag-clipboard'

export function useCreateFeatureFlagForm(onCreated: (key: string) => void) {
  const [name, setName] = useState('')
  const [key, setKey] = useState('')
  const [description, setDescription] = useState('')
  const mutation = useCreateFeatureFlag()
  const [pasteError, setPasteError] = useState<string | null>(null)
  const [pasted, setPasted] = useState(false)

  function applyPaste(text: string) {
    setPasted(false)
    setPasteError(null)
    try {
      const flag = parseFeatureFlagClipboard(text)
      setName(flag.name)
      setKey(flag.key)
      setDescription(flag.description ?? '')
      mutation.reset()
      setPasted(true)
    } catch (error) {
      setPasteError(
        error instanceof Error
          ? error.message
          : 'Could not read the pasted flag.',
      )
    }
  }

  const error = mutation.error
  const errorMessage =
    error && 'status' in error && error.status === 409
      ? 'This key is taken, by a flag or a deleted one. Choose a different key.'
      : error
        ? 'Could not create the flag. Your input has been kept. Please try again.'
        : null
  return {
    pasteError,
    pasted,
    handlePaste: (text: string) => {
      if (mutation.isPending || !isFeatureFlagClipboardText(text)) {
        return false
      }
      applyPaste(text)
      return true
    },
    name,
    setName,
    key,
    setKey,
    description,
    setDescription,
    mutation,
    errorMessage,
    submit: () =>
      mutation.mutate(
        { key, name: name.trim(), description: description.trim() },
        { onSuccess: (flag) => onCreated(flag.key) },
      ),
  }
}
